// Per-visitor 10-minute launch-price countdown.
// Starts the moment a visitor lands. Pinned in localStorage so a page refresh
// doesn't restart the urgency. If the visitor returns > 24 hours later, the
// timer resets to a fresh 10 minutes.

const STORAGE_KEY = "m2i_countdown_start";
const WINDOW_MS = 10 * 60 * 1000;          // 10 minutes
const RESET_AFTER_MS = 24 * 60 * 60 * 1000; // 24 h

const getStart = () => {
  if (typeof window === "undefined") return Date.now();
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const stored = raw ? parseInt(raw, 10) : NaN;
    const now = Date.now();
    if (!Number.isFinite(stored) || now - stored > RESET_AFTER_MS) {
      window.localStorage.setItem(STORAGE_KEY, String(now));
      return now;
    }
    return stored;
  } catch (_) {
    return Date.now();
  }
};

export const getLaunchRemaining = () => {
  const start = getStart();
  const target = start + WINDOW_MS;
  const now = Date.now();
  const diff = Math.max(0, target - now);
  const d = Math.floor(diff / 86_400_000);
  const h = Math.floor((diff % 86_400_000) / 3_600_000);
  const m = Math.floor((diff % 3_600_000) / 60_000);
  const s = Math.floor((diff % 60_000) / 1000);
  return { diff, d, h, m, s, ended: diff <= 0 };
};
